module.exports = __webpack_public_path__ + "pic/41.10ed54ed.png";